module.exports = __webpack_public_path__ + "img/icon_wph.91bb3903.png";